import { DateInput } from '@/components/DateInput';
import { selectAbnActiveFrom, setAbnActiveFrom } from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'AbnActiveFrom';

export function AbnActiveFromManual({
    baseId,
    showErrors,
}: IProps): JSX.Element {
    // ***** Redux *****
    const currentState = useAppSelector(selectAbnActiveFrom);
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    const handleChange = (date: Date): void => {
        const formattedDate = formatDateToString(date);
        dispatch(setAbnActiveFrom(formattedDate));
    };

    // ***** Render *****
    return (
        <div data-testid={testId} className='w-full'>
            <DateInput
                id={`${baseId}-input-abnActiveFrom`}
                title='Active From'
                placeholder='DD/MM/YYYY'
                onChange={handleChange}
                value={parseDate(currentState)}
                showErrors={showErrors && !currentState}
                maxDate={new Date()}
                tooltipContent='The date the ABN was registered.'
            />
        </div>
    );
}

// todo: move this to utils?
export function formatDateToString(date: Date | null): string {
    if (date == null) return '';
    const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    };

    return date.toLocaleDateString('en-GB', options);
}

export function parseDate(
    dateString: string | undefined | null
): Date | undefined {
    if (dateString === undefined || dateString === null) return undefined;
    const [day, month, year] = dateString.split('/');
    const parsedDate = new Date(
        parseInt(year),
        parseInt(month) - 1,
        parseInt(day)
    );
    return parsedDate;
}
